<template>
  <vs-popup class="add-new-carrier"
            id="popup"
            :title="isCreateMode ? 'ADD PRODUCTION CODE' : 'UPDATE PRODUCTION CODE'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-carrier-popup" @submit.prevent="handleSubmit(onClickCreateProductionCode)" autocomplete="off">

         <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="prefix" name="prefix" rules="required" v-slot="{ errors }">
                <small class="label">Prefix</small>
                <vs-input v-model="form.prefix"  name="prefix" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="form.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="formulation_type" name="formulation_type" rules="required" v-slot="{ errors }">
                <small class="label">Finished Good Product Form</small>
                <v-select name="formulation_type" :closeOnSelect="true" v-model="form.formulation_type"
                  :options="finishedGoodTypes" :reduce="option => option.value" label="label"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="show_formulation_percentage" name="show_formulation_percentage" rules="required" v-slot="{ errors }">
                <small class="label">Print Formulation Item Percentages on WO Label?</small>
                <YesNoToggle v-model="form.show_formulation_percentage" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div> -->

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <small class="label">Add Extra Days to Lead Times</small>
              <vs-input type="number" v-model="form.extra_lead_time" name="extra_lead_time_days" class="w-full" min="0" />
            </div>
          </div>

          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-production-codes-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  const CarrierRepository = RepositoryFactory.get('carrier');
  const ProductionCodeRepository = RepositoryFactory.get('production_code');

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'
  import YesNoToggle from "@/components/yes-no-toggle/YesNoToggle.vue"

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        name: '',
        extra_lead_time: 0
      },
      isCreateMode: true,
      finishedGoodTypes: [
        { value: 'Spray Dry Powder', label: 'Spray Dry Powder' },
        { value: 'Liquid',           label: 'Liquid' },
        { value: 'Powder',           label: 'Powder' },
        { value: 'Fruit',           label: 'Fruit' },
      ]
    }
  }

  export default {
    name: 'CreateCarrierPopUp',
    components: {
      'v-select': vSelect,
      YesNoToggle
    },
    data() {
      return initialState()
    },
    methods: {
      async openPopup(data) {
        try {
          Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
          if (!!data) {
            Object.assign(this.form, data)
            this.id = this.form.id
            this.isCreateMode = false
          } else {
            this.isCreateMode = true
          }
        } catch (error) {

        }
      },
      async onClickCreateProductionCode() {
        const vue = this;
        await this.$vs.loading({
          container: '#create-carrier-popup',
          scale: 0.45
        })
        try {
          if (this.isCreateMode) {
            await ProductionCodeRepository.createProductionCode(this.form);
            this.showSuccessMessage('Production code added successfully');
          } else {
            await ProductionCodeRepository.updateProductionCode(this.id, this.form);
            this.showSuccessMessage('Production code updated successfully');
          }
          await vue.$parent.refreshData();
          this.open = false;
        } catch (e) {
          this.$vs.loading.close('#create-carrier-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-carrier-popup > .con-vs-loading')
      },
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-carrier >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
